import { MaterialHero } from "../../components/static-page-components/material-hero";
import { SplitScreenBlock } from "../../components/static-page-components/split-screen-block";
import phoneImage from "../../assets/general/seal-on-phone.png";
import { Pages } from "../../utils";
import "./styles.scss";
import { LandingPageSection } from "../../components/static-page-components/landing-page-section";
import { Button, Grid2, Typography } from "@mui/material";
import { HomePageUserTypeBlock } from "../landing-page/user-type-block";
import magnifyImage from "../../assets/design-community/magnify.jpg";
import elevateImage from "../../assets/design-community/elevate.jpg";
import credibilityImage from "../../assets/design-community/credibility.jpg";
import territoryImage from "../../assets/join-as-designer-page/territory.jpg";
import { Link } from "react-router";
import { useState } from "react";
import { DesignerRequirementsPopup } from "../../components/designer-requirements-popup";
import { TerritoriesPopup } from "../../components/territories-popup";
import { OurGuaranteePopup } from "../../components/our-guarantee-popup";
import { TheVettingProcess } from "../../components/the-vetting-process";

export const DesignCommunityPage = () => {
  const [showGuaranteePopup, setShowGuaranteePopup] = useState(false);
  const [showDesignerRequirementsPopup, setShowDesignerRequirements] =
    useState(false);
  const [showTerritoriesPopup, setShowTerritoriesPopup] = useState(false);

  return (
    <div className="our-design-community-page">
      <MaterialHero title="Join Our Tribe" />

      <div className="site-wrapper">
        <SplitScreenBlock
          className="phone-split-screen-block"
          titleClassName="font-body"
          image={phoneImage}
          title="It’s time to expand your professional circle and boost your impact potential"
          description="Like any industry of craftsmen, designers are often left to fend for themselves. On the marketing front, this can keep you isolated and struggling to differentiate yourself. That’s why Home Design Guild has built an exclusive network of vetted interior designers and decorators who share your values, your drive, and your ambition to elevate industry standards. Here, you’ll find all the tools and resources you need to grow your business."
          to={Pages.SIGNUP}
          linkText="Apply Now"
          reverse
        />
      </div>

      <LandingPageSection>
        <Grid2 container spacing={"32px"} columns={12}>
          <HomePageUserTypeBlock
            title="Certified"
            description="Get listed as a certified HDG designer and attract premium clients."
            size={{
              xs: 12,
              md: 4,
            }}
          />
          <HomePageUserTypeBlock
            title="Trusted"
            description="Elevate your professional standing with a trusted industry seal and like minded community support."
            size={{
              xs: 12,
              md: 4,
            }}
          />
          <HomePageUserTypeBlock
            title="Esteemed"
            description="Network with a community of like-minded designers, gain insider knowledge, and more.   "
            size={{
              xs: 12,
              md: 4,
            }}
          />
        </Grid2>
      </LandingPageSection>

      <LandingPageSection>
        <Typography
          variant={"display2" as any}
          component="h2"
          className="section-title text-center font-title font-size-6"
        >
          SEE WHAT SETS OUR DESIGNER COMMUNITY APART
        </Typography>
      </LandingPageSection>

      <SplitScreenBlock
        image={magnifyImage}
        titleClassName="font-body"
        title="Screened & Certified"
        description="Every member of our design community is thoroughly vetted through a meticulous screening process. We’re committed to building a community of experts as committed as you are."
        onClick={() => setShowDesignerRequirements(true)}
        linkText="View Standards"
        backgroundImage
      />
      <DesignerRequirementsPopup
        visible={showDesignerRequirementsPopup}
        onClose={() => setShowDesignerRequirements(false)}
      />
      <SplitScreenBlock
        image={elevateImage}
        titleClassName="font-body"
        title="Elevate The Industry"
        description="Share ideas, innovations and support with designers who aim to build each other up, not compete or undercut. Here, we’re elevating the industry from the inside out by upholding the Home Design Guild Code of Conduct."
        to={`${Pages.ABOUT_DESIGN_HUB}#chatter`}
        linkText="Learn More"
        reverse
        backgroundImage
      />
      <SplitScreenBlock
        image={territoryImage}
        titleClassName="font-body"
        title="Territory Exclusivity"
        description="Memberships are limited per territory, preserving your uniqueness and positioning you as a design leader in your area. We limit market saturation, so you can be a go-to resource."
        onClick={() => setShowTerritoriesPopup(true)}
        linkText="See Territories"
        backgroundImage
      />
      <TerritoriesPopup
        visible={showTerritoriesPopup}
        onClose={() => setShowTerritoriesPopup(false)}
      />
      <SplitScreenBlock
        image={credibilityImage}
        titleClassName="font-body"
        title="Earned Credibility"
        description="For homeowners, the lack of industry standards makes it difficult to understand who to trust or hire. We help you set yourself apart as a Certified Home Guild Designer."
        onClick={() => setShowGuaranteePopup(true)}
        linkText="Our Guarantee"
        reverse
        backgroundImage
      />
      <OurGuaranteePopup
        visible={showGuaranteePopup}
        onClose={() => setShowGuaranteePopup(false)}
      />

      <TheVettingProcess />

      <LandingPageSection className="footer-section pink-section text-center">
        <Typography
          variant="h4"
          className="text-center font-body title"
          sx={{ mb: "20px" }}
        >
          {" "}
          Start Fueling Your Future With Home Design Guild
        </Typography>
        <Typography
          variant="body2"
          className="text-center contain-text section-subtitle font-size-4"
          sx={{
            mb: "28px",
          }}
        >
          Join Home Design Guild and experience the difference a designer-first
          platform can make.
        </Typography>

        <Button
          component={Link}
          variant="contained"
          size="large"
          to={Pages.SIGNUP}
          color={"white" as any}
          className="font-size-4"
        >
          Apply Now
        </Button>
      </LandingPageSection>
    </div>
  );
};
